(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const speed = 0.35; // effet bien visible

  const main = document.querySelector('#MainContent') || document.querySelector('main');
  if (!main) return;

  const firstSection = main.querySelector('.shopify-section');
  if (!firstSection) return;

  const img =
    firstSection.querySelector('.banner__media img') ||
    firstSection.querySelector('img');

  if (!img) return;

  img.style.willChange = 'transform';

  let lastY = 0;
  let currentY = 0;

  const animate = () => {
    currentY += (lastY - currentY) * 0.08;
    img.style.transform = `translate3d(0, ${currentY}px, 0)`;
    requestAnimationFrame(animate);
  };

  window.addEventListener(
    'scroll',
    () => {
      lastY = (window.scrollY || window.pageYOffset) * -speed;
    },
    { passive: true }
  );

  animate();
})();